import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import { isEmptyScObj } from "../../utils/siteUtils";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import Input from "../../elements/input";
import { SuperButton } from "../../elements";
import React, { useState } from "react";
import { getEncryptor } from "../../services/siteService";
import api from "../../utils/api";
import { LOGOUT } from "../../redux/actions";
function AccountPasswordSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountPasswordSettingMain {...props} />;
  }
}
function AccountPasswordSettingMain(props) {
  /** Password */
  const [oldPasswordEntered, setOldPasswordEntered] = useState();
  const [oldPasswordValid, setOldPasswordValid] = useState(true);
  const [oldPasswordError, setOldPasswordError] = useState(null);
  const [newPasswordEntered, setNewPasswordEntered] = useState();
  const [newPasswordValid, setNewPasswordValid] = useState(true);
  const [newPasswordError, setNewPasswordError] = useState(null);
  const [changePasswordButtonIsDisabled, setChangePasswordButtonIsDisabled] = useState(true);
  const [serverError, setServerError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const {
    user,
    logout,
    fields: {
      contentHeadingType,
      contentHeadingBody,
      contentBody,
      oldPasswordLabel,
      oldPasswordInfoMessage,
      oldPasswordMissingMessage,
      oldPasswordWarningMessage,
      newPasswordLabel,
      newPasswordInfoMessage,
      newPasswordMissingMessage,
      newPasswordWarningMessage,
      updateFailedMessage,
      updateSuccessMessage,
      ctaTypeChangePassword,
      ctaNameChangePassword,
      colorSchemeChangePassword,
      iconNameChangePassword
    }
  } = props;
  const onOldPasswordFocus = evt => {
    setIsUpdated(false);
    setServerError(null);
    setOldPasswordValid(true);
    setOldPasswordError(null);
  };
  const onOldPasswordChanged = (evt, isValid) => {
    setOldPasswordEntered(evt.target.value);
    setChangePasswordButtonIsDisabled(evt.target.value !== "" && newPasswordEntered && newPasswordValid ? false : true);
    setOldPasswordValid(isValid);
  };
  const onNewPasswordFocus = evt => {
    setIsUpdated(false);
    setServerError(null);
    setNewPasswordValid(true);
    setNewPasswordError(null);
  };
  const onNewPasswordChanged = (evt, isValid) => {
    setNewPasswordEntered(evt.target.value);
    setNewPasswordValid(isValid);
    setNewPasswordError(isValid ? null : newPasswordWarningMessage.value);
    setChangePasswordButtonIsDisabled(evt.target.value !== "" && isValid && oldPasswordEntered ? false : true);
  };

  const onSubmitPasswordChange = async evt => {
    let valid = true;
    if (!oldPasswordEntered) {
      setOldPasswordError(oldPasswordMissingMessage.value);
      valid = false;
    } else if (!oldPasswordValid) {
      valid = false;
      setOldPasswordError(oldPasswordWarningMessage.value);
    }
    if (!newPasswordEntered) {
      setNewPasswordError(newPasswordMissingMessage.value);
      valid = false;
    } else if (!newPasswordValid) {
      valid = false;
      setNewPasswordError(newPasswordWarningMessage.value);
    }
    if (valid) {
      try {
        const encryptor = await getEncryptor(user.email);
        let data = {
          oldPassword: encryptor.encrypt(oldPasswordEntered),
          newPassword: encryptor.encrypt(newPasswordEntered),
          userAccount: user.userAccount
        };
        setChangePasswordButtonIsDisabled(true);
        await api.password.update(null, data);
        setIsUpdated(true);
        setTimeout(() => {
          logout();
        }, 500);
      } catch (ex) {
        setServerError(updateFailedMessage.value);
      } finally {
        setChangePasswordButtonIsDisabled(false);
      }
    }
  };
  const oldPasswordProps = {
    type: "password",
    label: oldPasswordLabel.value,
    infoMessage: oldPasswordInfoMessage.value,
    showError: oldPasswordError !== null,
    warningMessage: oldPasswordError,
    onChange: (evt, isValid) => onOldPasswordChanged(evt, isValid),
    onFocus: evt => onOldPasswordFocus(evt)
  };
  const newPasswordProps = {
    type: "password",
    label: newPasswordLabel.value,
    infoMessage: newPasswordInfoMessage.value,
    showError: newPasswordError !== null,
    warningMessage: newPasswordError,
    onChange: (evt, isValid) => onNewPasswordChanged(evt, isValid),
    onFocus: evt => onNewPasswordFocus(evt)
  };
  const ctaChangePassword = {
    ctaType: ctaTypeChangePassword,
    buttonText: ctaNameChangePassword.value,
    colorScheme: colorSchemeChangePassword,
    iconName: iconNameChangePassword,
    isDisabled: changePasswordButtonIsDisabled,
    callback: evt => onSubmitPasswordChange(evt)
  };
  return (
    <div className="section">
      <Heading type={contentHeadingType} typographyClass="type-h3" html={contentHeadingBody} />
      <BodyText html={contentBody.value} className="form-section-builder-section-body" />

      <Input {...oldPasswordProps} skipValidation={true} />
      <Input {...newPasswordProps} />

      {serverError !== null && <BodyText className="failed-message" html={serverError} />}
      {isUpdated && <BodyText className="success-message" html={updateSuccessMessage.value} />}
      <SuperButton {...ctaChangePassword} />
    </div>
  );
}
const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  logout: (...args) => dispatch({ type: LOGOUT, ...args })
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountPasswordSetting);
